import slugify from 'slugify';
import sanitize from 'sanitize-filename';

const baseName = (projectName, fallback) => sanitize(slugify(projectName)) || fallback;

/** File name for the download of a project's uploaded binary. */
export const uploadedFileName = (projectName) => `${baseName(projectName, 'uploaded-file')}-uploaded.bin`;

/** File name for the export of a project's modified binary. */
export const exportedFileName = (projectName) => `${baseName(projectName, 'exported-file')}.bin`;
